import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
  open: boolean;
  handleClose: () => void;

  title: string;
  description: string;
  loading: boolean;
  confirmButtonLabel?: string;
  onSubmit: () => Promise<void>;
};

export default function ConfirmationDialog({
  open,
  handleClose,
  description,
  loading,
  title,
  onSubmit,
  confirmButtonLabel = 'Ok',
}: Props) {
  const handleSubmit = async () => {
    await onSubmit();
    handleClose();
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleClose}>
          Cancel
        </Button>
        <Button disabled={loading} onClick={handleSubmit} autoFocus>
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
